export default __webpack_public_path__ + "static/media/dark_green.566833cf.png";